"use client";
import { useEffect, useState } from "react";

import PageHead from "./../Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import BackToTop from "./../backToTop";
import FooterThree from "@/components/Footer/Footer-Three";
import { getBlogs, getData, getTestiMonials } from "@/Action/api";
import Cart from "@/components/Header/Offcanvas/Cart";
import { useParams } from "next/navigation";
import TeamFour, { VideoPlayer } from "@/components/Team/TeamFour";
import Footersection from "@/components/Category/Footersection";

import axios from "axios";
import { ASSETS_URL } from "@/Constant";
import CategorySix from "@/components/Category/CategorySix";
import SmallContactSection from "@/components/Category/smallContactSection";
import TeamOne from "@/components/Team/TeamOne";
import GlobalAccordion from "@/components/Accordions/Global-Accordion";
import FaqSchema from "@/components/SEO/FaqSchema";
import { getCountryFaqs } from "@/lib/api/faqs";
import { getCountry } from "@/lib/api/country";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import CourseTabs from "@/components/Category/FIlter/CourseTabs";

const why_study_data = {
  header: "Why Study In",
  description:
    "Study in one of the most prestigious higher education systems globally and access some high-end technology and cutting-edge research for an immersive, engaging & collaborative study experience. Choose from an extensive range of schools, numerous study disciplines and niche qualifications that are difficult to find by in other parts of the world and experience a uniquely flexible education system allowing you to apply to a variety of programs suiting your academic & career goals. Graduate with a truly global outlook and real-world skills for the future.",
  quickFacts: [
    {
      id: 1,
      label: "This Country hosts more than a million international students",
    },
    {
      id: 2,
      label: "Over 25% of world’s top 100 universities are in the USA",
    },
    {
      id: 3,
      label: "Post-study stay back visas (OPT) up to 3 years for STEM programs",
    },
    {
      id: 4,
      label: "Internships (CPT) up to 12 months while studying",
    },
    { id: 5, label: "Merit Based & Need Based Scholarships" },
    {
      id: 6,
      label: "Over 4500 accredited universities & institutions to choose from",
    },
    {
      id: 7,
      label:
        "12 of the best student cities in the world (QS Best Student Cities 2024",
    },
    {
      id: 8,
      label: "Opportunities for Research, Teaching & Graduate Assistantships",
    },
  ],

  studyCost: {
    description:
      '<p>&nbsp;</p><p>Test University tuition fees vary depending on the chosen course and are reviewed annually. The fees may vary for domestic and international students. International fees are reviewed annually and not fixed for the duration of studies. To determine eligibility for tuition fees, students can refer to the UK Council for International Student Affairs (UKCISA) guidelines or seek advice from UKCISA.<br>&nbsp;</p><p>The university determines each student’s fee status based on their unique circumstances and the information they submit, ensuring a fair assessment for everyone.</p><figure className="table"><table><thead><tr><th>Types of Expenses</th><th>Annual Expenses in INR</th></tr></thead><tbody><tr><td>Annual Avg PG Tuition fee</td><td>X - Y Lakhs</td></tr><tr><td>Annual Avg UG Tuition fee</td><td>X - Y Lakhs</td></tr><tr><td>Annual Avg Accommodation &amp; food expenses</td><td>X - Y Lakhs</td></tr></tbody></table></figure><p>&nbsp;</p>',
  },
  careerProsPects: {
    title: "Career Prospects in",
    description:
      "The employment landscape in Australia offers opportunities across various sectors.Here are some key sectors and industries that presently offer employment opportunities:",
    sections: [
      {
        id: 1,
        title: "Engineering",
        image: "/images/Destination/computer_science_engerring.jpg",
      },
      {
        id: 2,
        title: "Digital Services & IT",
        image: "/images/Destination/digitalservicesandit.jpg",
      },
      {
        id: 3,
        title: "Education & training",
        image: "/images/Destination/Education_and_training.jpg",
      },
      {
        id: 4,
        title: "Mining & Resources",
        image: "/images/Destination/Miningandresources.jpg",
      },
      {
        id: 5,
        title: "Agribusiness",
        image: "/images/Destination/agribusiness.jpg",
      },
      {
        id: 6,
        title: "Healthcare",
        image: "/images/Destination/Healthcare.jpg",
      },
    ],
  },
};

const infoCards = [
  {
    icon: "🎓",
    title: "Globally Recognised Degrees",
    description:
      "Australian degrees are recognised and valued across the globe. This means that if you study in Australia and complete a program, the degree will prove to be of great value for finding employment or pursuing further education anywhere in the world.",
  },
  {
    icon: "🏙️",
    title: "Seven Of The Best Student Cities In The World",
    description:
      "According to the QS Best Student Cities Rankings for 2024, seven cities in Australia have secured positions within the top 100 best student cities worldwide.",
  },
  {
    icon: "💼",
    title: "Post-Study Work Up To 6 Years",
    description:
      "Students who have completed their degree in Australia are eligible for post-study work visa ranging from 2 to 4 years, depending on whether they studied a Bachelor's, Master's or Doctoral degree. Additionally, those studying and living in designated regional areas can obtain a visa for up to 6 years.",
  },
];

const getTruncatedText = (htmlString, wordLimit = 10) => {
  // Create a temporary element to parse HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;

  // Get the plain text content
  const textContent = tempDiv.textContent || tempDiv.innerText || "";

  // Truncate to the specified number of words
  const words = textContent.trim().split(/\s+/);
  const truncated = words.slice(0, wordLimit).join(" ");

  return truncated;
};
const StudyCourses = ({ faqs, country }) => {
  // Seeded from getServerSideProps so the H1 renders the real country name in
  // the initial HTML instead of "Study in undefined"; the client fetch below
  // refreshes it with the same payload.
  const [CountryData, setCountryData] = useState(country || {});
  const [loading, setLoading] = useState(false); // Loader state
  const [activeTab, setActiveTab] = useState("tab1");
  const [universitiesData, setUniversitiesData] = useState();
  const [selectedTabData, setselectedTabData] = useState();
  const [testiMonials, setTestiMonials] = useState([]);
  const [blogsData, setBlogsData] = useState([]);

  const params = useParams();
  const gradient1 =
    "linear-gradient(25deg, rgb(14, 20, 46) 50%, rgb(157, 86, 24) 100%)";
  const style = {
    // background: toggleBackground ? gradient1 : gradient2,
    background: gradient1,
    transition: "background 0.3s ease",
  };

  const getSelectedCourse = [];

  // Countries like Germany have neither states nor universities in the CMS yet —
  // hide the whole "Top Universities" block instead of rendering an empty section.
  const hasUniversities =
    universitiesData?.length > 0 || selectedTabData?.University?.length > 0;

  const fetchdata = async () => {
    setLoading(true); // Set loading to true when fetching starts
    try {
      const response = await getData(`/get/country/${params?.id}`);
      const response2 = await getData(`/get/country/${params?.id}/university`);
      // countryId comes from the country payload (e.g. 82 for Germany) and scopes
      // the university list to this country — without it the API returns every country's.
      handleStateSelection(0, response2?.data?.[0], response?.data?.countryId);
      setUniversitiesData(response2?.data);
      setCountryData(response?.data);
    } catch (error) {
      console.error("Error fetching country data:", error);
    } finally {
      setLoading(false); // Set loading to false when fetch completes
    }
  };

  const fetChTestiMonials = async () => {
    try {
      const result = await getTestiMonials();
      if (result?.res?.success) {
        setTestiMonials(result?.res?.data?.story);
      }
    } catch (error) {
      console.error("Error fetching country:", error);
    }
  };

  const fetchBlogs = async () => {
    try {
      const result = await getBlogs();
      if (result?.res?.success) {
        setBlogsData(result?.res?.data);
      }
    } catch (error) {
      console.error("Error fetching country:", error);
    }
  };
  const handleStateSelection = async (index, value, countryId) => {
    try {
      const payload = { country: countryId ?? CountryData?.countryId };
      if (value?.stateId) {
        payload.state = value.stateId;
      }
      const result = await axios.post(`/get/university`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setselectedTabData(result?.data?.data);
      // result
    } catch (err) {
      console.error(err);
    }
    setActiveTab(index);
  };

  useEffect(() => {
    if (params?.id) {
      fetchdata();
      fetChTestiMonials();
      fetchBlogs();
    }
  }, [params?.id]);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsMobile(window.innerWidth < 767);
    }
  }, []);
  return (
    <>
      <PageHead
        title="Course-Immigration Guru's"
        description="Study abroad destination guide from The Immigration Gurus — top universities, popular courses, living costs, visa requirements and intake timelines."
      />
      <FaqSchema items={faqs} />

      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType={true} />
          <MobileMenu />
          <Cart />

          <div className="">
            {loading ? (
              <div className="loader-container">
                <div className="loader"></div>
              </div>
            ) : (
              <div
                className=""
                style={{
                  backgroundImage: isMobile
                    ? CountryData?.bannermobile
                      ? `url(${ASSETS_URL}/${CountryData?.bannermobile})`
                      : `url(${ASSETS_URL}/${CountryData?.banner})`
                    : `url(${ASSETS_URL}/${CountryData?.banner})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "500px",
                  maxHeight: "500px",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    position: "absolute",
                    background: "black",
                    opacity: "0.3",
                  }}
                ></div>
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    position: "absolute",
                  }}
                >
                  <div
                    className="container h-100 d-flex "
                    style={{
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="d-flex align-items-center gap-4 responsive_widht_50">
                      <div>
                        <h1 className="h3" style={{ color: "white" }}>
                          {CountryData?.heading
                            ? CountryData?.heading
                            : ` Study in ${CountryData?.countryName}`}
                        </h1>
                        {CountryData?.subheading && (
                          <p
                            className="description text-white"
                            style={{
                              color: "white",
                            }}
                          >
                            {CountryData?.subheading}
                          </p>
                        )}
                      </div>
                    </div>
                    <div
                      className="p-[2rem] responsive_widht_50 hiddleVisibility "
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="d-grid grid-cols-2 gap-4"
                        style={{
                          padding: "2rem",
                          ...style,
                          borderRadius: "12px",
                        }}
                      >
                        <SmallContactSection
                          column={6}
                          isFull={false}
                          Text={"white"}
                          isRemoveAreaCode={true}
                          defaultDestinationId={CountryData?.countryId}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className=" container rbt-video-area bg-color-extra2 rbt-section-gapTop rbt-section-gapBottom visible_mobile">
            {" "}
            <SmallContactSection
              column={12}
              isFull={false}
              defaultDestinationId={CountryData?.countryId}
            />
          </div>

          {!loading && (
            <>
              <div
                className="rbt-video-area bg-color-white rbt-section-gapTop rbt-section-gapBottom"
                id="about"
              >
                <div className="container">
                  <div className="row g-5 align-items-center">
                    <div className="col-lg-6">
                      <div className="inner ">
                        <div className="section-title text-start">
                          <h4 className="title">{CountryData?.title}</h4>
                          <p className="description mt--30">
                            {CountryData?.discription}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="video-popup-wrapper">
                        <VideoPlayer
                          videoSrc={`${ASSETS_URL}/${CountryData?.video}`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {CountryData?.studysteps?.length > 0 && (
                <div
                  className="rbt-video-area bg-color-extra2 rbt-section-gapTop rbt-section-gapBottom"
                  id="about"
                >
                  <div className="container">
                    <div className="row g-5 ">
                      <div className="col-lg-8">
                        <div className="inner ">
                          <div className="section-title text-start">
                            <h4 className="title mb-4">
                              {why_study_data?.header}{" "}
                              {CountryData?.countryName}
                            </h4>
                            <div
                              className="d-grid grid gap-4"
                              style={{
                                display: "grid",
                              }}
                            >
                              {CountryData?.studysteps?.map((card, index) => (
                                <div
                                  key={index}
                                  className="d-flex items-start gap-2 p-6 border-b border-gray-200 last:border-b-0 universal_border p-4"
                                >
                                  {/* Icon Container */}
                                  <div className="flex-shrink-0 flex d-flex items-center mt-2">
                                    <i className="feather-bookmark"></i>
                                  </div>

                                  {/* Content */}
                                  <div className="flex-1 min-w-0">
                                    <div className="fw-bold mb-2">
                                      {card.title}
                                    </div>

                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: `
        <style>
          p {
            margin: 0 !important;
            padding: 0 !important;
            line-height: inherit !important;
          }
          span {
          color: inherit !important;
          }
          h2 span {
          color: #E1793F !important
          }
        </style>
        ${card.discription}
      `,
                                      }}
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="d-grid gap-4">
                          <SmallContactSection
                            defaultDestinationId={CountryData?.countryId}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {CountryData?.costToStudy?.discription && (
                <section className="rbt-course-area  bg-color-white rbt-section-gap">
                  <div className="container">
                    <div className="section-title text-center mb-4">
                      <h2 className="title">
                        Cost of Study in{" "}
                        <span
                          className="text-[#DB6827] color_important"
                          style={{
                            color: "#DB6827 !important",
                            textDecoration: "underline",
                          }}
                        >
                          {CountryData?.countryName}
                        </span>
                      </h2>
                    </div>

                    <div className="mt-2">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `
  <style>
    p {
      margin: 0 !important;
      padding: 0 !important;
      line-height: inherit !important;
    }
    span {
      color: inherit !important;
    }
    table {
      border-collapse: collapse !important;
      width: 100% !important;
      border: 2px solid #e6e3f1 !important;
      color: #6b7385 !important;
      font-family: Arial, sans-serif !important;
    }
    th, td {
      border: 1px solid #ddd !important;
      padding: 12px 16px !important;
      font-weight: 400 !important;
      text-align: left !important;
      color: #6b7385 !important;
      background-color: transparent !important;
    }
    thead {
      background-color: transparent !important;
    }
    th {
      font-weight: 600 !important;
      color: #6b7385 !important;
      width: 50% !important;
    }
    
  </style>
  ${CountryData?.costToStudy?.discription}
`,
                        }}
                      />
                    </div>
                  </div>
                </section>
              )}
              {hasUniversities && (
                <div className="rbt-course-area bg-color-extra2 rbt-section-gap">
                  <div className="container">
                    <div className="row mb--60">
                      <div className="col-lg-12">
                        <div className="section-title text-center">
                          {/* <span className="subtitle bg-secondary-opacity">Courses</span> */}
                          <h2 className="title">
                            Top Universities in {CountryData?.countryName}
                          </h2>
                        </div>
                      </div>
                    </div>
                    {/* <CourseSix /> */}
                  </div>
                  <div className="container">
                    <div style={{ width: "100%" }}>
                      <div>
                        <ul
                          style={{
                            display: "flex",
                            gap: "0.75rem",
                            listStyle: "none",
                            padding: 0,
                            borderBottom: "none",
                            overflow: "auto",
                          }}
                        >
                          {universitiesData?.map((item, index) => (
                            <li key={index} style={{ margin: 0 }}>
                              <button
                                style={{
                                  padding: "1rem 1.5rem",
                                  color:
                                    activeTab === index ? "#DB6827" : "#6B7280",
                                  fontWeight: 500,
                                  borderBottom:
                                    activeTab === index
                                      ? "2px solid #DB6827"
                                      : "2px solid transparent",
                                  outline: "none",
                                  cursor: "pointer",
                                  background: "none",
                                  border: "none",
                                  width: "max-content",
                                }}
                                className="w-max"
                                onClick={() =>
                                  handleStateSelection(index, item)
                                }
                              >
                                {item?.stateName}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* <CourseSix Data={Projects?.events ?? []} /> */}
                    </div>
                  </div>

                  <div className="container">
                    <CourseTabs
                      Projects={selectedTabData}
                      course={getSelectedCourse}
                      childDataCallable={"University"}
                    />
                  </div>
                </div>
              )}
              <div className="rbt-course-area bg-color-white rbt-section-gap">
                <div className="container">
                  <div className="row mb--60">
                    <div className="col-lg-12">
                      <div className="section-title text-center">
                        {/* <span className="subtitle bg-secondary-opacity">Courses</span> */}
                        <h2 className="title">
                          Popular Courses in {CountryData?.countryName}
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div className=" row g-5 mobileviewpadding">
                    <CategorySix />
                  </div>
                </div>
              </div>

              {CountryData?.category?.length > 0 && (
                <div className="rbt-course-area bg-color-extra2 rbt-section-gap">
                  <div className="container">
                    <div className="row mb--60">
                      <div className="col-lg-12">
                        <div className="section-title text-center">
                          {/* <span className="subtitle bg-secondary-opacity">Courses</span> */}
                          <h2 className="title">
                            Career Prospects in {CountryData?.countryName}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div className=" row g-5 mobileviewpadding">
                      <div className="container">
                        <div className="row row--15 mt_dec--30">
                          {CountryData?.category?.map((member, index) => (
                            <div
                              key={index}
                              className="col-lg-4 col-md-6 col-12 mt--30"
                            >
                              <div className="rbt-team team-style-default style-three rbt-hover">
                                <div className="inner">
                                  <div
                                    className="thumbnail"
                                    style={{
                                      backgroundImage: `url(${ASSETS_URL}/uploads/prospects/${member?.id}/${member?.image?.src})`,
                                      backgroundSize: "cover",
                                      backgroundPosition: "center",
                                      height: "250px",
                                      width: "100%",
                                      maxHeight: "250px",
                                    }}
                                  ></div>
                                  <div className="content">
                                    {/* <h2 className="title">{member.name}</h2> */}
                                    <h6 className="subtitle theme-gradient">
                                      {member.name}
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="rbt-team-area bg-color-white pb--60 pt--60 ">
                <div className="container">
                  <div className="row mb--60">
                    <div className="col-lg-12">
                      <div className="section-title text-center">
                        <h2 className="title">Testimonial</h2>
                      </div>
                    </div>
                  </div>

                  <TeamOne TestiMonialsData={testiMonials} />
                </div>
              </div>
              {CountryData?.faqs?.length > 0 && (
                <div className="rbt-team-area bg-color-extra2 pb--60 pt--60 ">
                  <div className="container">
                    <div className="row mb--60">
                      <div className="col-lg-12">
                        <div className="section-title text-center">
                          <h2 className="title">
                            Frequently Asked Questions(FAQ's).
                          </h2>
                        </div>
                      </div>
                    </div>
                    <GlobalAccordion data={CountryData?.faqs ?? []} />
                  </div>
                </div>
              )}
              {blogsData?.length > 0 && (
                <div className="rbt-team-area bg-color-white pb--60 pt--60 ">
                  <div className="container">
                    <div className="row mb--60">
                      <div className="col-lg-12">
                        <div className="section-title text-center">
                          <h2 className="title mb-4">Blogs</h2>
                        </div>

                        <div className="row">
                          {blogsData?.map((item, index) => (
                            <div
                              key={index}
                              className="col-lg-4 col-md-6 col-sm-12 mt-4"
                            >
                              <div className="rbt-card variation-02 rbt-hover">
                                <div
                                  className="rbt-card-img"
                                  style={{
                                    backgroundImage: `url(${ASSETS_URL}/uploads/blogs/${item?.id}/${item?.image?.src})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    height: "250px",
                                    width: "100%",
                                  }}
                                ></div>
                                <div className="rbt-card-body">
                                  <h5 className="rbt-card-title">
                                    <a href={`/blog-details/${item.slug}`}>
                                      {item.title}
                                    </a>
                                  </h5>
                                  <div
                                    className="rbt-card-text"
                                    dangerouslySetInnerHTML={{
                                      __html: `
              <style>
                p {
                  margin: 0 !important;
                  padding: 0 !important;
                  line-height: inherit !important;
                }
                span {
                  color: inherit !important;
                }
                table {
                  border-collapse: collapse !important;
                  width: 100% !important;
                  border: 2px solid #e6e3f1 !important;
                  color: #6b7385 !important;
                  font-family: Arial, sans-serif !important;
                }
                th, td {
                  border: 1px solid #ddd !important;
                  padding: 12px 16px !important;
                  font-weight: 400 !important;
                  text-align: left !important;
                  color: #6b7385 !important;
                  background-color: transparent !important;
                }
                thead {
                  background-color: transparent !important;
                }
                th {
                  font-weight: 600 !important;
                  color: #6b7385 !important;
                  width: 50% !important;
                }
                
              </style>
              ${getTruncatedText(item.discription)}
            `,
                                    }}
                                  ></div>
                                  <div className="rbt-card-bottom">
                                    <a
                                      className="transparent-button"
                                      href={`/blog-details/${item.slug}`}
                                    >
                                      Learn More
                                      <i>
                                        <svg
                                          width="17"
                                          height="12"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g
                                            stroke="#27374D"
                                            fill="none"
                                            fillRule="evenodd"
                                          >
                                            <path d="M10.614 0l5.629 5.629-5.63 5.629"></path>
                                            <path
                                              strokeLinecap="square"
                                              d="M.663 5.572h14.594"
                                            ></path>
                                          </g>
                                        </svg>
                                      </i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    {/* <TeamFour isHead={false} showvideos={showvideos} /> */}
                  </div>
                </div>
              )}
            </>
          )}

          <BackToTop />

          <div className="rbt-categories-area pb--40  pt--60" style={style}>
            <div className="container">
              <div className="row g-5  ">
                <div
                  className="service-wrapper  bg-color-te"
                  style={{
                    background: "inherit",
                  }}
                >
                  <Footersection defaultDestinationId={CountryData?.countryId} />
                </div>
              </div>
            </div>
          </div>

          <FooterThree />
        </Context>
      </Provider>

      <style jsx>{`
        .loader-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 500px;
        }
        .loader {
          border: 4px solid #f3f3f3;
          border-top: 4px solid #3498db;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </>
  );
};

export default StudyCourses;

export async function getServerSideProps({ params }) {
  // An unknown slug (/dashboard, a typo) must 404 rather than render the
  // template with "Study in undefined". getCountry only reports notFound when
  // the API actually says the country is missing.
  const { notFound, country } = await getCountry(params?.id);
  if (notFound) {
    return { notFound: true };
  }

  // FAQs ride along on the same payload so crawlers that don't execute JS still
  // see the Q&A; the country lookup already fetched them.
  const faqs = Array.isArray(country?.faqs)
    ? country.faqs
    : await getCountryFaqs(params?.id);

  return {
    props: { faqs, country: country ?? null },
  };
}
